<template>
	<a
		:href="link"
		class="l-carousel-wrapper-team card-league-small"
	>
		<div class="card-league-small__inner">
			<div class="card-league-small__logo-w">
				<img
					class="card-league-small__logo"
					alt=""
					:src="imageUrl"
				>
			</div>
			<div class="card-league-small__title-wrapper">
				<h4
					class="card-league-small__title"
					v-text="item.name"
				/>
			</div>
		</div>
	</a>
</template>

<script>
import laroute from '@laroute';

export default {
	name:  'LeagueCardSmall',
	props: {
		item: {
			type:     Object,
			required: true,
		},
		clickable: {
			type:     Boolean,
			required: false,
			default:  true,
		},
	},
	data() {
		return {
			laroute,
		};
	},
	computed: {
		imageUrl: function() {
			return this.$Helpers && !(this.item?.imageUrl ?? '').includes('background_auth')
				? this.$Helpers.getScaledImageUrl(this.item.imageUrl, 180)
				: null;
		},
		link: function() {
			return laroute.route('arena.league', { league: this.item.id, slug: $Helpers.slugify(this.item.name) });
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.card-league-small {
	display: inline-block;
}

.card-league-small__inner {
	display: flex;
	flex-direction: column;
	text-align: center;
	background-color: var(--color-grey-900);
	border-radius: var(--t-border-radius-card--lg);
	width: 100%;
	height: 100%;
	padding: 0 $sp3 $sp4;
	border: 1px solid var(--color-grey-800);
	transition: transform $trans-time-fast, background-color $trans-time-fast;
	will-change: transform, background-color;
	cursor: pointer;

	.is-keynav-section-active .is-selected & {
		transform: scale(1.09);
		background-color: var(--color-grey-850);
		border: 3px solid var(--color-hype-yellow);
		border-radius: 3px;
	}

	body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
		@include box-shadow(1);
		background-color: var(--color-white);
		border: none;
	}

	&:focus,
	&:hover {
		transform: scale(1.09);
	}
}

.card-league-small__title {
	@include font-size(fs-80);

	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box; // stylelint-disable-line value-no-vendor-prefix
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical; // stylelint-disable-line property-no-vendor-prefix

	body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
		@include font(primary, bold, normal, fs-80);
		color: var(--color-black);
	}
}

.card-league-small__logo-w {
	margin: $sp4 0 $sp3-5 0;
	display: flex;
	justify-content: center;
	align-items: center;
}

.card-league-small__logo {
	width: 54px;
}

.card-league-small__title-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-grow: 1;
}

</style>
